// extracted by mini-css-extract-plugin
module.exports = {"tabIcon":"NavigationTab_tabIcon__23GBD","tabTitle":"NavigationTab_tabTitle__1RYi8","InActiveTab":"NavigationTab_InActiveTab__1kwQV","ActiveTab":"NavigationTab_ActiveTab__MUxej"};